import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPDATE_AB_TEST: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation updateAbTest($input: UpdateAbTestInput!) {
    updateAbTest(input: $input) {
      abTest {
        status
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
